import esTranslations from './es.json'
import ptTranslations from './pt.json'

let translations = {
  es: esTranslations,
  pt: ptTranslations,
}

export { translations }